<!-- eslint-disable -->
<template lang="pug">
		.settings(v-if="settings")
				| {{ $i18n.t('trainer.trainer_gameFormSetting_difficulty') }}: {{ difficultyStringified(settings.difficult)}}
				br
				| {{ $i18n.t('trainer.trainer_gameFormSetting_displaySpeed') }}: {{settings.speed}} {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
				br
				template(v-if="settings.duration")
						| {{ $i18n.t('trainer.trainer_gameFormSetting_gameDuration') }}:
						| {{ settings.duration }}
						| {{ $i18n.t('trainer.trainer_gameFormSettingValue_minutes') }}
				template(v-if="settings.isSeries")
						| {{ $i18n.t('trainer.trainer_gameFormSetting_numOfSeries') }}: {{ settings.seriesAmount }}<br>
						| {{ $i18n.t('trainer.trainer_gameFormSetting_numsInSeries') }}: {{ settings.seriesExamples }}
				template(v-else-if="settings.amount")
						| {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}: {{ settings.amount }}
				br
				slot
</template>

<script>
    /*eslint-disable*/
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import FlashCardsPreviewMixin from "../../../utils/trainer/FlashCardsPreviewMixin";
    import gamePreviewMixin from "../../../utils/trainer/gamePreviewMixin";
    import {getInitParameters} from "../../../utils/trainer/getInitParameters";

    export default {
        mixins: [TrainerUtilities, FlashCardsPreviewMixin, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            userId: Number
        }
    }
</script>
